/**
 * Opens the program in the FIESTA WebApp.
 * @param programId The id of the program to join.
 */
export function joinCampaign(programId: string) {
  let tabUrl =
    process.env.REACT_APP_DIRECT_JOIN_URL;

  if (!tabUrl) {
    console.warn('FIESTA_APP_DIRECT_JOIN_URL is missing');
    tabUrl = 'https://app.fiesta.club/flows/pdj/__PROGRAM_ID__';
  }

  tabUrl =
    tabUrl.replace('__PROGRAM_ID__', programId);

  // We want to pass all parameters along, that contain tracking parameters.
  const urlBuilder = new URL(tabUrl);
  const searchParams = new URLSearchParams(window.location.search);
  searchParams
    .forEach(
      (value, key) => {
        if (key.startsWith('tp_'))
          urlBuilder.searchParams.set(key, value);
      }
    );

  openTab(urlBuilder.href);
}

/**
 * Opens a URL in a new tab.
 * @param url The URL to open in the new tab.
 */
export function openTab(url: string) {
  window.open(url, '_blank');
}